module.exports = require('./agent')();
